import React, { useState, forwardRef, useEffect, useRef, useImperativeHandle } from "react";

import { Dropdown } from "primereact/dropdown";
import studentsAPI from "../../../../services/students";
import levelsAPI from "../../../../services/levels";
import classesAPI from "../../../../services/classes";
import { Dialog } from "primereact/dialog";
import MeaButton from "../../../../components/MeaButton";
import { Toast } from "primereact/toast";


const UpdateStudentAffectationModal = forwardRef((props, ref) => {
  //
  const { schoolId, trainingId } = props;
  const accessToken = "";
  //
  const [student, setStudent] = useState(null);
  const [classId, setClassId] = useState("");
  const [levelId, setLevelId] = useState("");
  //
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });
  const toast = useRef(null);
  //
  const levelsQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000,
    {
      level_id: levelId,
    }
  );
  //
  useImperativeHandle(ref, () => ({
    show: (student, callback) => {
      setStudent(student);
      setLevelId(student?.level_id || "");
      setClassId(student?.class_id || "");
      setCallbackFn(() => callback);
      setActive(true);
    },
  }));
  //
  const handleUpdateSubmit = async (e) => {
    // Handle update action
    setLoading(true);

    studentsAPI.UpdateClass(schoolId, trainingId, accessToken, student?.id, classId, levelId)
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: "Modification effectuée avec succès!",
        });
        setActive(false);
        setLoading(false);
        callbackFn();
        //
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
        setActive(false);
        setLoading(false);
        callbackFn();
      })
  };
  //
  const footerContent = (
    <div>
      <MeaButton
        label="Annuler"
        icon="pi pi-times"
        disabled={loading}
        loading={loading}
        onClick={() => setActive(false)}
        className="p-button-text"
      />
      <MeaButton
        type="submit"
        loading={loading}
        disabled={!classId}
        label="Enregister"
        icon="pi pi-save"
        onClick={() => handleUpdateSubmit()}
      />
    </div>
  );
  //
  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        focusOnShow={false}
        header="Modification de niveau / classe"
        visible={active}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setActive(false)}
        footer={footerContent}
      >
        <div className="w-full">
          <div className="flex flex-column gap-2">
            <label htmlFor="level" className="block text-900 mt-4 font-medium mb-2">
              Niveau
            </label>
            <Dropdown
              value={levelsQuery?.data?.data?.find((obj) => obj.id === levelId)}
              onChange={(e) => {
                setLevelId(e.value?.id);
                setClassId("");
              }}
              options={levelsQuery?.data?.data}
              optionLabel="name"
              className="w-full mb-3"
            />
            <label htmlFor="classe" className="block text-900 font-medium mb-2">
              Classe
            </label>
            <Dropdown
              disabled={
                levelId === null || levelId === undefined || levelId === ""
              }
              value={classesQuery?.data?.data?.find(
                (obj) => obj.id === classId
              )}
              onChange={(e) => setClassId(e.value?.id)}
              options={classesQuery?.data?.data}
              optionLabel="name"
              className="w-full mb-3"
            />
          </div>
        </div>
      </Dialog>
    </>
  );
});

export default UpdateStudentAffectationModal;
